import { createRoot } from 'react-dom/client';
import moment from 'moment';
import { Provider } from 'react-redux';
import configureStore from './state/configureStore'
import App from './app.js';
import { getUser } from './actions/apiGetInfo';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://2f5ee5b0a0e0001ceebc4b55ebc0656c@o141269.ingest.us.sentry.io/4511739540668416",
  integrations: [Sentry.browserTracingIntegration()],
  sampleRate: 0.1,
  tracesSampleRate: 0.1,
});

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

export const { store } = configureStore({})
let authentication = JSON.parse(localStorage.getItem('authentication'))
if (authentication && authentication.access_token) {
	store.dispatch(getUser());
}

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
